import { useRouter } from "next/router";
import { useCallback, useEffect } from "react";

type UseRouterPushWithPrefetch = (path: string) => () => void;

/**
 * prefetchを事前に行い、pushを行う
 *
 * 注意: 遅い回線などで prefetch のチャンク読み込みが timeout (3.8 秒) で reject されると、
 * その読み込み中に呼ばれた push が永久に pending のまま止まり、遷移しなくなりうる (Next.js の Pages Router (route-loader) の挙動。16.3.5 / 16.3.8 で確認)。
 * 新しく遷移を足すときは、遷移が止まるリスクを許容できるかを踏まえて、この hook と prefetch しない router.push のどちらを使うかを判断する。
 * 詳細は PR #7569 を参照。
 */
export const useRouterPushWithPrefetch: UseRouterPushWithPrefetch = (path) => {
  const router = useRouter();

  useEffect(() => {
    router.prefetch(path);
  }, [router, path]);

  const handleRouterPush = useCallback(async () => {
    router.push(path);
  }, [router, path]);

  return handleRouterPush;
};
